import styled from "styled-components"
import PlayerCardHolder from "./PlayerCardHolder"
import PitcherLabel from "./PitcherLabel"
import { useSquad } from "../contexts/SquadContext"


const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 40rem;
    height: 100%;
    justify-content: center;
    align-items: center;
    margin-top: 1.675rem;
`

const VerticalContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`

const HorizontalContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 90%;
    justify-content: space-between;
`

export default function PitcherSquadMaker() {

    const { playerInfos, addPlayer, removePlayer } = useSquad();

    return (
        <Container>
            <HorizontalContainer>

                <VerticalContainer>
                    <PitcherLabel
                        position="SP1"
                    ></PitcherLabel>
                    <PlayerCardHolder
                        position="SP1"
                        player={playerInfos['SP1']}>
                    </PlayerCardHolder>
                </VerticalContainer>

                <VerticalContainer>
                    <PitcherLabel
                        position="SP2"
                    ></PitcherLabel>
                    <PlayerCardHolder
                        position="SP2"
                        player={playerInfos['SP2']}>
                    </PlayerCardHolder>
                </VerticalContainer>

                <VerticalContainer>
                    <PitcherLabel
                        position="SP3"
                    ></PitcherLabel>
                    <PlayerCardHolder
                        position="SP3"
                        player={playerInfos['SP3']}>
                    </PlayerCardHolder>
                </VerticalContainer>

                <VerticalContainer>
                    <PitcherLabel
                        position="SP4"
                    ></PitcherLabel>
                    <PlayerCardHolder
                        position="SP4"
                        player={playerInfos['SP4']}>
                    </PlayerCardHolder>
                </VerticalContainer>

                <VerticalContainer>
                    <PitcherLabel
                        position="SP5"
                    ></PitcherLabel>
                    <PlayerCardHolder
                        position="SP5"
                        player={playerInfos['SP5']}>
                    </PlayerCardHolder>
                </VerticalContainer>
                
            </HorizontalContainer>

            <div style={{ height: '1.25rem' }}></div>

            <HorizontalContainer>

                <VerticalContainer>
                    <PitcherLabel
                        position="WIN"
                    ></PitcherLabel>

                    <PlayerCardHolder
                        position="RP1"
                        player={playerInfos['RP1']}>
                    </PlayerCardHolder>

                    <PlayerCardHolder
                        position="RP2"
                        player={playerInfos['RP2']}>
                    </PlayerCardHolder>

                    <PlayerCardHolder
                        position="RP3"
                        player={playerInfos['RP3']}>
                    </PlayerCardHolder>
                </VerticalContainer>

                <VerticalContainer>
                    <PitcherLabel
                        position="CHA"
                    ></PitcherLabel>
                    <PlayerCardHolder
                        position="RP4"
                        player={playerInfos['RP4']}>
                    </PlayerCardHolder>

                    <PlayerCardHolder
                        position="RP5"
                        player={playerInfos['RP5']}>
                    </PlayerCardHolder>
                </VerticalContainer>

                <VerticalContainer>
                    <PitcherLabel
                        position="LNG"
                    ></PitcherLabel>
                    <PlayerCardHolder
                        position="RP6"
                        player={playerInfos['RP6']}>
                    </PlayerCardHolder>
                </VerticalContainer>

                <VerticalContainer>
                    <PitcherLabel
                        position="CP"
                    ></PitcherLabel>
                    <PlayerCardHolder
                        position="CP"
                        player={playerInfos['CP']}>
                    </PlayerCardHolder>
                </VerticalContainer>

            </HorizontalContainer>

        </Container>
    )
};